import {default as CONFIG} from '../config.js';
import {extend} from '../zviz2/zviz/functions.js';

const defaultStyles = {
    h1Blue: {
        font: {family: 'Overpass', size: 24, weight: 'bold', color: [255, 255, 255]},
        backgroundColor: [30, 45, 190]
    },
    h2: {font: {family: 'Noto Sans', size: 15, weight: 'bold'}},
    h2Blue: {
        font: {family: 'Noto Sans', size: 11, weight: 'bold', color: [255, 255, 255]},
        backgroundColor: [30, 45, 190]
    },
    italic: {font: {family: 'Noto Sans', size: 11, style: 'italic', weight: 'bold'}},
    number: {font: {family: 'Noto Sans'}, format: '#,##0'},
    float: {font: {family: 'Noto Sans'}, format: '0.00'},
    percentage: {font: {family: 'Noto Sans'}, format: '0.00%'},
    blue: {backgroundColor: [30, 45, 190], font: {family: 'Noto Sans', color: [255, 255, 255]}},
    date: {font: {family: 'Noto Sans'}, format: 14}, // 14 is a Excel preset for m/d/yy
    default: {font: {family: 'Noto Sans'}}
};

class ExcelExport {

    /**
     * 
     * @param {number} rowNr the row number starting at 1
     * @param {number} colNr the column number starting at 0
     * @returns string indicating the cell, e.g.: getCellLocation(4, 1) -> 'B4'
     */
    getCellLocation(rowNr, colNr){
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        if(colNr < letters.length){
            return letters.substring(colNr, colNr + 1) + rowNr;
        }
        const m = colNr % letters.length;
        const i = Math.floor(colNr / letters.length);
        const col = letters.substring(i - 1, i) + letters.substring(m, m + 1);
        return col + rowNr;
    }
    
    constructor(styles = {}, formatHeader = null, formatFooter = null){
        this.formatHeader = formatHeader || this.formatHeaderDefault;
        this.formatFooter = formatFooter || this.formatFooterDefault;
        this.workbook = {
            styles: extend(styles, defaultStyles),
            sheets: []
        }
    }

    /**
     * 
     * @param {Object} sheet 
     * @returns {number} the row to start the data
     */
    formatHeaderDefault(sheet){

        return 1;
    }
    

    /**
     * 
     * @param {Object} sheet 
     * @param {number} row the row to start the footer
     */
    formatFooterDefault(sheet, row){

    }

    addSheet(name, layout, cells = {}){
        const sheet = {
            name: name ? name : ('Sheet ' + (this.workbook.sheets.length + 1)),
            layout: layout || {columns: {default: {width: 15}}, rows: {}},
            cells
        };
        this.workbook.sheets.push(sheet);
    }

    /**
     * 
     * @param {Array} data 
     * @param {Array} columns 
     * [{
     *      id: 'column_id',
     *      title: 'Column Title',
     *      style: 'date',
     *      parse: () => {}
     *      headerStyle: 'h2Blue'
     *      width: 20
     * }]
     */
    addDataSheet(data, columns, name = null){
        const sheet = {
            name: name ? name : ('Sheet ' + (this.workbook.sheets.length + 1)),
            layout: {
                columns: columns.reduce((cols, cur, index) => {
                    if(cur.width){
                        cols[index] = {width: cur.width}
                    }
                    return cols;
                }, {default: {width: 15}}),
                rows: {}
            },
            cells: {}
        };

        let rowNr = this.formatHeader(sheet);
        
        // insert column headers
        for(let colNr = 0; colNr < columns.length; colNr++){
            const column = columns[colNr];
            const cell = this.getCellLocation(rowNr, colNr);
            sheet.cells[cell] = {
                value: column.title,
                style: column.headerStyle || 'h2Blue'
            };
        }
        rowNr++;

        // insert data
        for(const row of data){
            for(let colNr = 0; colNr < columns.length; colNr++){
                const column = columns[colNr];
                const cell = this.getCellLocation(rowNr, colNr);
                sheet.cells[cell] = {
                    value: row[column.id] || '',
                    style: column.style || 'default'
                };
            }
            rowNr++;
        }

        this.formatFooter(rowNr);

        this.workbook.sheets.push(sheet);

    }

    download(filename = 'ilo-export.xslx', excelServiceEndpoint = CONFIG.excelServiceEndpoint){

        const form = document.createElement("form");
        form.method = "POST";
        form.action = excelServiceEndpoint;
        // form.target = '_blank';

        for(const key of Object.keys(this.workbook)){
            const element = document.createElement("input");
            element.value = JSON.stringify(this.workbook[key]);
            element.name = key;
            element.type = 'hidden';
            form.appendChild(element);
        }
        const element = document.createElement("input");
        element.value = filename;
        element.name = 'filename';
        element.type = 'hidden';
        form.appendChild(element);

        document.body.appendChild(form);
        form.submit();
        form.parentNode.removeChild(form);
    }
    
}

export {ExcelExport};
